import {Component} from 'react'
import PropTypes from 'prop-types'
import Aperture from 'react-feather/dist/icons/aperture.js'
import Edit from 'react-feather/dist/icons/edit.js'
import Trash from 'react-feather/dist/icons/trash.js'
import ChevronDown from 'react-feather/dist/icons/chevron-down.js'
import ChevronUp from 'react-feather/dist/icons/chevron-up.js'

import api from '../../../../../api.js'
import connectModal from '../../../../../shared/components/Modals/connect.js'
import Date from '../../../../../shared/components/Moment/Date.jsx'
import MissionModal from '../../../Modals/Mission/MissionModal.jsx'
import DeleteMissionModal from '../../../Modals/Mission/DeleteMissionModal.jsx'
import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx"
import connect from "react-redux/lib/connect/connect.js"
import {isAdmin} from "../../../../../shared/services/userService.js"

class Mission extends Component {
  static propTypes = {
    freelance: PropTypes.object.isRequired,
    experiences: PropTypes.array,
    onClose: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      experiencesVisibility: []
    }
  }

  componentDidMount() {
    const { experiences } = this.props
    const { isAdmin } = this.props

    const visibilityArray = experiences?.map((_, index) => {
      return this.props.canEdit ? isAdmin ? true : index === 0 : true
    })

    this.setState({
      experiencesVisibility: visibilityArray
    })
  }

  editExistingMission = (offset, experienceId) => {
    this.props.openMissionModal({
      freelance: this.props.freelance,
      experiences: this.props.experiences,
      onClose: this.props.onClose,
      onSubmit: this.props.submit,
      offset,
      experienceId
    })
  }

  beautifyMission = (offset, experienceId) => {
    const experience = this.props.experiences[offset]
    const beautifyPromise = api.freelances.aiMissionDetailBeautification({
      freelance: this.props.freelance.id,
      detail: experience.description
    })
    this.props.openMissionModal({
      freelance: this.props.freelance,
      experiences: this.props.experiences,
      onClose: this.props.onClose,
      onSubmit: this.props.submit,
      offset,
      experienceId,
      beautifyPromise
    })
  }

  deleteMission = (offset, experienceId) => {
    this.props.openDeleteMissionModal({
      freelance: this.props.freelance,
      experiences: this.props.experiences,
      onClose: this.props.onClose,
      offset,
      experienceId
    })
  }

  toggle = (offset) => {
    this.setState((prevState) => {
      const updatedVisibility = [...prevState.experiencesVisibility]
      updatedVisibility[offset] = !updatedVisibility[offset]
      return { experiencesVisibility: updatedVisibility }
    })
  }

  isVisible = (offset) => {
    const { experiencesVisibility } = this.state
    return experiencesVisibility[offset] ?? false
  }

  render() {

    return (
      <div>
        {this.props?.experiences?.map((experience, offset) => (
          <div
            className={this.props.className}
            id={`experiences-${experience.id}`}
            key={`experience-${experience.id}`}
          >
            {this.props.canEdit ?
              <CardRow justify="flex-end" gap="10px">
                <div
                  onClick={() => this.beautifyMission(offset, experience.id)}
                  className="btn btn btn-outline-secondary btn-sm"
                >
                  <Aperture size={14} style={{ marginRight: 6 }} />
                  Enrichir le contenu
                </div>
                <div
                  onClick={() => this.toggle(offset)}
                  className="btn btn btn-outline-secondary btn-round btn-sm"
                >
                  {this.isVisible(offset) ? <ChevronDown /> : <ChevronUp/> }
                </div>
                <div
                  onClick={() => this.editExistingMission(offset, experience.id)}
                  className="btn btn btn-outline-primary btn-round btn-sm"
                >
                  <Edit />
                </div>
                <div
                  onClick={() => this.deleteMission(offset, experience.id)}
                  className="btn btn btn-outline-danger btn-round btn-sm"
                >
                  <Trash />
                </div>
              </CardRow>
              : ''
            }

            {(experience.title || experience.locality || experience.company) &&
              <div className="break-inside">
                <h3 className="sub-sub-title">{experience.title}</h3>
                {experience.title && experience.company && <span> chez </span>}
                {experience.company && <b>{experience.company}</b>}
                {(experience.company || experience.title) && experience.locality && <span> - </span>}
                {experience.locality && <span>{experience.locality}</span>}
              </div>
            }

            {(experience.start || experience.end || experience.current) &&
            <div className="break-inside">
              {(experience.start && <Date format="MM/yyyy" date={experience.start} />)}
              {(experience.start && (experience.current || experience.end) && <span> - </span>)}
              {(experience.current
                ? <span>Aujourd'hui</span>
                : (experience.end && <Date format="MM/yyyy" date={experience.end} />)
              )}
            </div>
            }

            { this.isVisible(offset) ? <div className="mission-description mt-4" dangerouslySetInnerHTML={{__html: experience.description}} /> : '' }
          </div>
        ))}
      </div>
    )
  }
}

export default  connect(
  state => ({
    currentUser: state.currentUser.user,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(connectModal({ MissionModal, DeleteMissionModal }, Mission))
